import { render, staticRenderFns } from "./payPopUp.vue?vue&type=template&id=9960c14a&scoped=true"
import script from "./payPopUp.vue?vue&type=script&lang=js"
export * from "./payPopUp.vue?vue&type=script&lang=js"
import style0 from "./payPopUp.vue?vue&type=style&index=0&id=9960c14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9960c14a",
  null
  
)

export default component.exports